import { Box, Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const CardButton = ({ title, description, to, image, isMobile = false }) => {
  const cardStyle = {};
  const cardActionStyle = { borderRadius: '10px' };
  const boxStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };
  const cardMediaStyle = { m: '16px', height: '85px', width: '85px', objectFit: 'contain' };
  const cardContentStyle = {};
  const titleStyle = { fontWeight: 'bold' };

  if (isMobile) {
    cardStyle.height = {
      xs: '100px',
      sm: '130px',
      overflow: 'hidden',
      boxShadow: '0 2px 4px rgba(0,0,0,0.02), 0 10px 20px rgba(0,0,0,0.06)',
      borderRadius: '16px',
    };

    cardActionStyle.height = '100%';

    boxStyle.flexDirection = 'column';
    boxStyle.justifyContent = 'center';
    boxStyle.gap = '8px';
    boxStyle.padding = '8px';
    boxStyle.height = '100%';

    cardMediaStyle.margin = '0';
    cardMediaStyle.height = { xs: '35px', sm: '55px' };
    cardMediaStyle.width = { xs: '35px', sm: '55px' };

    cardContentStyle.padding = '0';
    cardContentStyle.paddingBottom = '0 !important';

    titleStyle.fontSize = { xs: '0.7rem', sm: '0.875rem' };
    titleStyle.textAlign = 'center';
    titleStyle.marginBottom = '0 !important';
    titleStyle.lineHeight = { xs: '1.2em', sm: '1.4em' };
  }

  return (
    <Card sx={{ ...cardStyle }}>
      <CardActionArea
        sx={{ ...cardActionStyle }}
        component={Link}
        to={to || '/'}
        aria-label={title}
      >
        <Box sx={{ ...boxStyle }}>
          <CardMedia
            component='img'
            sx={{ ...cardMediaStyle }}
            image={image}
            alt={`imagen de ${title}`}
          />
          <CardContent sx={{ ...cardContentStyle }}>
            {title && (
              <Typography gutterBottom variant='h6' component='h2' sx={{ ...titleStyle }}>
                {title}
              </Typography>
            )}
            {description && !isMobile && (
              <Typography variant='body2' color='textSecondary' component='p'>
                {description}
              </Typography>
            )}
          </CardContent>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default CardButton;
